/* eslint-disable react/prop-types */
import React from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { cloneChildComponents } from '../utils/helpers'

// Generic success body to display a review of the actions completed in the workflow
function GenericSuccessBody(props) {
  const { children, ...rest } = props
  const { actionData, successData, completedActions } = rest

  return (
    <Form>
      <Modal.Body>
        <Row>
          <Col sm="12" md="12" lg="12">
            {/* Display any successful action ids */}
            {/* eslint-disable-next-line array-callback-return, consistent-return */}
            {successData?.successActions.map((successfulAction) => {
              const { actionId } = successfulAction

              // The action was completed, display it
              if (actionId && completedActions.includes(actionId)) {
                const displayBelowVariableName = successfulAction?.displayBelow // The variable that is intended to be displayed below the action success message
                const displayBelowObjectKey = successfulAction?.displayBelowObjectKey // If displayBelowVariableName is an object, this is the key for the value to display
                const actionIdEnJsonVariableId = successfulAction?.actionIdEnJsonVariableId // If the formatted message has a variable input to insert
                const displayAction = successfulAction?.displayAction // An actionId is to be printed out for each element in this array
                const displayActionObjectKey = successfulAction?.displayActionObjectKey // The value to insert into the formatted message
                const outcomeIconClass = successfulAction.failed
                  ? 'icon-lg font-color-danger fas fa-circle-xmark'
                  : 'icon-lg font-color-engage fas fa-circle-check'
                const outcomeTextClass = successfulAction.failed ? 'ms-3 font-color-danger' : 'ms-3'

                return (
                  <>
                    {/* Iterate over the displayAction array in actionData and print out the actionId for each iteration */}
                    {actionData && actionData[displayAction] && Array.isArray(actionData[displayAction]) ? (
                      <>
                        {actionData[displayAction].map((actionIdToDisplay, index) => (
                          <p key={actionIdToDisplay?.id || actionIdToDisplay?.name || index}>
                            <span className={outcomeIconClass} />
                            <span className={outcomeTextClass}>
                              <FormattedMessage
                                id={actionId}
                                defaultMessage={successfulAction.defaultMessage}
                                values={{
                                  [actionIdEnJsonVariableId]: actionIdToDisplay[displayActionObjectKey],
                                }}
                              />
                            </span>
                          </p>
                        ))}
                      </>
                    ) : (
                      <>
                        {/* Just display the actionId a single time */}
                        <p>
                          <span className={outcomeIconClass} />
                          <span className={outcomeTextClass}>
                            <FormattedMessage id={actionId} defaultMessage={successfulAction.defaultMessage} />
                          </span>
                        </p>
                      </>
                    )}

                    {/* Items to display below the successful action, items are in an array */}
                    {actionData &&
                    actionData[displayBelowVariableName] &&
                    Array.isArray(actionData[displayBelowVariableName]) ? (
                      <ul>
                        {actionData &&
                          actionData[displayBelowVariableName].map((itemToDisplayBelow, i) => (
                            <li
                              key={i} // eslint-disable-line react/no-array-index-key
                              className="mb-0"
                              style={{ marginLeft: '0.5rem' }}
                            >
                              {displayBelowObjectKey ? itemToDisplayBelow[displayBelowObjectKey] : itemToDisplayBelow}
                            </li>
                          ))}
                      </ul>
                    ) : (
                      <>
                        {/* Item is a single value (object or variable) */}
                        {actionData && actionData[displayBelowVariableName] && (
                          <ul>
                            <li className="mb-0" style={{ marginLeft: '0.5rem' }}>
                              {displayBelowObjectKey
                                ? actionData[displayBelowVariableName][displayBelowObjectKey]
                                : actionData[displayBelowVariableName]}
                            </li>
                          </ul>
                        )}
                      </>
                    )}
                  </>
                )
              }
            })}
          </Col>
        </Row>
      </Modal.Body>

      {/* Footer Child */}
      {cloneChildComponents({ ...rest }, children)}
    </Form>
  )
}

export default GenericSuccessBody
